// エンドポイント: GET /api/v1/tenants/{tenantId}/shipments/{shipmentId}
export const getTenantShipmentEndpoint = (tenantId: number, shipmentId: number): string =>
  `/tenants/${tenantId}/shipments/${shipmentId}`
